import React, { useEffect, useState } from 'react'
import { MapContainer as Map, Marker, Popup, TileLayer } from 'react-leaflet';

import { Polo, SquadraInSessione as Squadra } from '../api/types';
import { ENTERPRISE } from '../globals';
import { get_polo } from '../api';
import { Link } from 'react-router-dom';

interface ownProps {
  squadre: Squadra[]
  evento: number
}


const get_coords: (polo: Polo) => [number, number] = (polo) => {
  if (!polo.indirizzo || !polo.indirizzo.latitude || !polo.indirizzo.longitude) {
    return ENTERPRISE;
  }
  return [parseFloat(polo.indirizzo.latitude), parseFloat(polo.indirizzo.longitude)]
}



const MappaPoli = ({ squadre, evento }: ownProps) => {
  const [poli, setPoli] = useState<Polo[]>([])

  useEffect(() => {
    get_polo({ evento: evento }).then(setPoli);
  }, [])


  const dati = poli.map(polo => {
    const sq = squadre.filter(sq => sq.polo === polo.id);
    const desc = `Capacità: ${sq.length} / ${polo.capacita_massima_squadre}`
    return {
      nome: polo.nome_breve,
      coords: get_coords(polo),
      desc: desc,
    }
  })


  return (
    <div className="overflow-auto">
      <h3>Attenzione</h3>
      <p>Una lista più dettagliata dei poli è reperibile <Link to={`/lista-poli/${evento}/`}>qui</Link></p>

      <Map center={ENTERPRISE} zoom={7} style={{ minHeight: '1300px', minWidth: '600px' }}

      >
        <TileLayer
          url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />
        {dati.map(item =>
          <Marker position={item.coords} key={item.nome}>
            <Popup>{item.nome}<br />{item.desc}</Popup>
          </Marker>
        )}
      </Map>
    </div >
  )
}


export default MappaPoli;
